/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { useInitialized } from './useInitialized.js';
import 'react';

var ShouldRender = function ShouldRender(props) {
  var shouldRender = useShouldRender(props.active, props.forceRender, props.destroyOnClose);
  return shouldRender ? props.children : null;
};
function useShouldRender(active, forceRender, destroyOnClose) {
  var initialized = useInitialized(active);
  if (forceRender) return true;
  if (active) return true;
  if (!initialized) return false;
  return !destroyOnClose;
}

export { ShouldRender, useShouldRender };
//# sourceMappingURL=useShouldRender.js.map
